import { render } from "./ExternalVmsSentMessages.vue?vue&type=template&id=3be2f68a&ts=true"
import script from "./ExternalVmsSentMessages.vue?vue&type=script&lang=tsx"
export * from "./ExternalVmsSentMessages.vue?vue&type=script&lang=tsx"

import "./ExternalVmsSentMessages.vue?vue&type=style&index=0&id=3be2f68a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__